(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
  (function() {
    var section = document.getElementById('collection-section');
    if (!section) return;
    var sectionId = section.dataset.sectionId;
    var collectionUrl = section.dataset.collectionUrl;

    /* Trim partial bottom row.
       Colour-sibling dedupe in the Liquid loop makes the rendered card count
       per paginated chunk unpredictable (e.g. 24 products -> 21 cards), so the
       bottom row can hold 1-3 cards instead of a full row of 4. Hide trailing
       cards so the visible count is always a multiple of 4 (the xl grid width
       and LCM of all breakpoints, so the row stays full on md/mobile too).
       Hidden cards stay in the DOM and reveal automatically when later loads
       bring the total to the next multiple of 4, or when there are no more
       paginated pages, in which case we show the partial row rather than
       permanently hiding products. */
    function trimPartialRow() {
      var grid = document.getElementById('collection-product-grid');
      if (!grid) return;
      var btn = document.getElementById('load-more-btn');
      var hasMore = btn && btn.dataset.nextUrl;
      var cards = Array.prototype.slice.call(grid.children);
      var total = cards.length;
      var target = hasMore ? Math.floor(total / 4) * 4 : total;
      if (target === 0) target = total;
      for (var i = 0; i < cards.length; i++) {
        if (i < target) {
          cards[i].removeAttribute('data-row-trimmed');
          cards[i].style.removeProperty('display');
        } else {
          cards[i].setAttribute('data-row-trimmed', '');
          cards[i].style.display = 'none';
        }
      }
    }

    /* ---- Swym wishlist button init ---- */
    function reinitSwym() {
      document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
    }

    if (!window.SwymCallbacks) { window.SwymCallbacks = []; }
    window.SwymCallbacks.push(function(swat) {
      document.addEventListener('swym:collections-loaded', function() {
        swat.initializeActionButtons('#collection-product-grid');
      });
      swat.initializeActionButtons('#collection-product-grid');
    });

    /* ---- Section Rendering API fetch ---- */
    function fetchSection(url) {
      var grid = document.getElementById('collection-product-grid');
      if (grid) grid.style.opacity = '0.5';

      var separator = url.indexOf('?') !== -1 ? '&' : '?';
      return fetch(url + separator + 'sections=' + sectionId)
        .then(function(r) { return r.json(); })
        .then(function(json) {
          var html = json[sectionId];
          if (!html) return;

          var doc = new DOMParser().parseFromString(html, 'text/html');

          /* Replace product grid */
          var newGrid = doc.getElementById('collection-product-grid');
          var curGrid = document.getElementById('collection-product-grid');
          if (newGrid && curGrid) {
            curGrid.innerHTML = newGrid.innerHTML;
            curGrid.style.opacity = '';
          }

          /* Replace load-more container */
          var newLM = doc.getElementById('load-more-container');
          var curLM = document.getElementById('load-more-container');
          if (newLM) {
            if (curLM) { curLM.replaceWith(newLM); }
            else if (curGrid) { curGrid.insertAdjacentElement('afterend', newLM); }
          } else if (curLM) {
            curLM.remove();
          }

          /* Replace empty state */
          var newEmpty = doc.querySelector('[data-collection-empty]');
          var curEmpty = document.querySelector('[data-collection-empty]');
          if (newEmpty && !curEmpty && curGrid) {
            curGrid.insertAdjacentElement('afterend', newEmpty);
          } else if (!newEmpty && curEmpty) {
            curEmpty.remove();
          } else if (newEmpty && curEmpty) {
            curEmpty.replaceWith(newEmpty);
          }

          /* Replace filter sidebar inner content (keeps outer shell for animation) */
          var curSidebar = document.querySelector('[data-filter-sidebar]');
          var newSidebar = doc.querySelector('[data-filter-sidebar]');
          if (curSidebar && newSidebar) {
            curSidebar.innerHTML = newSidebar.innerHTML;
          }

          /* Replace bottom action buttons (clear disabled state etc.) */
          var curActions = document.querySelector('[data-filter-actions]');
          var newActions = doc.querySelector('[data-filter-actions]');
          if (curActions && newActions) {
            curActions.innerHTML = newActions.innerHTML;
          }

          /* Update URL without reload */
          history.pushState(null, '', url);

          /* Grid was replaced with a fresh page 1 — reset the loaded-pages counter */
          section.dataset.loadedPages = '1';

          /* Scroll to top of grid on filter/sort change */
          if (grid) window.scrollTo({ top: section.offsetTop, behavior: 'smooth' });

          trimPartialRow();
          reinitSwym();
        })
        .catch(function() {
          if (grid) grid.style.opacity = '';
        });
    }

    /* ---- Build filter URL from form ---- */
    function getFilterUrl() {
      var form = document.getElementById('CollectionFiltersForm');
      if (!form) return collectionUrl;
      var params = new URLSearchParams(new FormData(form));
      /* Preserve sort_by if set */
      var current = new URL(window.location.href);
      var sortBy = current.searchParams.get('sort_by');
      if (sortBy) params.set('sort_by', sortBy);
      /* Remove empty params */
      var clean = new URLSearchParams();
      params.forEach(function(v, k) { if (v !== '') clean.append(k, v); });
      var qs = clean.toString();
      return qs ? collectionUrl + '?' + qs : collectionUrl;
    }

    /* ---- Event delegation: change ---- */
    document.addEventListener('change', function(e) {
      if (e.target.matches('[data-collection-sort]')) {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        fetchSection(url.toString());
        return;
      }
      if (e.target.matches('[data-filter-checkbox]')) {
        fetchSection(getFilterUrl());
        return;
      }
    });

    /* ---- Event delegation: form submit (price range) ---- */
    document.addEventListener('submit', function(e) {
      if (e.target.matches('#CollectionFiltersForm')) {
        e.preventDefault();
        fetchSection(getFilterUrl());
      }
    });

    /* ---- Event delegation: click ---- */
    document.addEventListener('click', function(e) {
      /* Active filter pill remove */
      var pill = e.target.closest('[data-filter-pill]');
      if (pill) {
        e.preventDefault();
        fetchSection(pill.getAttribute('href'));
        return;
      }

      /* Clear all filters */
      var clearBtn = e.target.closest('[data-filter-clear-btn]');
      if (clearBtn && !clearBtn.disabled) {
        var current = new URL(window.location.href);
        var sortBy = current.searchParams.get('sort_by');
        var url = collectionUrl;
        if (sortBy) url += '?sort_by=' + sortBy;
        fetchSection(url);
        return;
      }

      /* Load more */
      var loadBtn = e.target.closest('#load-more-btn');
      if (loadBtn) {
        handleLoadMore(loadBtn);
        return;
      }

      /* Filter sidebar open/close/view */
      if (e.target.closest('[data-filter-open-btn]')) { openFilters(); return; }
      if (e.target.closest('[data-filter-close-btn]')) { closeFilters(); return; }
      if (e.target.closest('[data-filter-view-btn]')) { closeFilters(); return; }
      if (e.target.matches('[data-filter-backdrop]')) { closeFilters(); return; }
    });

    /* ---- Filter sidebar open / close ---- */
    function openFilters() {
      var sidebar = document.querySelector('[data-filter-sidebar]');
      var backdrop = document.querySelector('[data-filter-backdrop]');
      if (sidebar) sidebar.setAttribute('data-filter-open', 'true');
      if (backdrop) backdrop.setAttribute('data-filter-open', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeFilters() {
      var sidebar = document.querySelector('[data-filter-sidebar]');
      var backdrop = document.querySelector('[data-filter-backdrop]');
      if (sidebar) sidebar.setAttribute('data-filter-open', 'false');
      if (backdrop) backdrop.setAttribute('data-filter-open', 'false');
      document.body.style.overflow = '';
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeFilters();
    });

    /* ---- Load more (append, don't replace) ---- */
    function handleLoadMore(btn) {
      var nextUrl = btn.dataset.nextUrl;
      if (!nextUrl) return;
      btn.textContent = 'Loading...';
      btn.disabled = true;

      var separator = nextUrl.indexOf('?') !== -1 ? '&' : '?';
      fetch(nextUrl + separator + 'sections=' + sectionId)
        .then(function(r) { return r.json(); })
        .then(function(json) {
          var html = json[sectionId];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('collection-product-grid');
          var curGrid = document.getElementById('collection-product-grid');

          if (newGrid && curGrid) {
            while (newGrid.firstChild) {
              curGrid.appendChild(newGrid.firstChild);
            }
          }

          var newBtn = doc.getElementById('load-more-btn');
          if (newBtn && newBtn.dataset.nextUrl) {
            btn.dataset.nextUrl = newBtn.dataset.nextUrl;
            btn.textContent = btn.dataset.label || 'Load more';
            btn.disabled = false;
          } else {
            btn.parentElement.remove();
          }

          var prevLoaded = parseInt(section.dataset.loadedPages || '1', 10);
          section.dataset.loadedPages = String(prevLoaded + 1);

          trimPartialRow();
          reinitSwym();
        })
        .catch(function() {
          btn.textContent = btn.dataset.label || 'Load more';
          btn.disabled = false;
        });
    }

    /* ---- Browser back/forward ---- */
    window.addEventListener('popstate', function() {
      fetchSection(window.location.href);
    });

    /* ---- Scroll restore when returning from a PDP ---- */
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    function plpStateKey() {
      return 'plp-state:' + window.location.pathname + window.location.search;
    }

    window.addEventListener('pagehide', function() {
      var loadedPages = parseInt(section.dataset.loadedPages || '1', 10);
      if (loadedPages <= 1) {
        try { sessionStorage.removeItem(plpStateKey()); } catch (_) {}
        return;
      }
      try {
        sessionStorage.setItem(plpStateKey(), JSON.stringify({
          loadedPages: loadedPages,
          scrollY: window.scrollY || window.pageYOffset || 0
        }));
      } catch (_) {}
    });

    function rehydrateLoadedPages(targetPages, scrollY) {
      var grid = document.getElementById('collection-product-grid');
      if (!grid) { window.scrollTo(0, scrollY); return; }
      grid.style.opacity = '0.5';

      var page = 2;
      function loadNext() {
        if (page > targetPages) {
          grid.style.opacity = '';
          section.dataset.loadedPages = String(targetPages);
          window.scrollTo(0, scrollY);
          trimPartialRow();
          reinitSwym();
          return;
        }
        var u = new URL(window.location.href);
        u.searchParams.set('page', page);
        var pageUrl = u.pathname + u.search;
        var sep = pageUrl.indexOf('?') !== -1 ? '&' : '?';
        fetch(pageUrl + sep + 'sections=' + sectionId)
          .then(function(r) { return r.json(); })
          .then(function(json) {
            var html = json[sectionId];
            if (!html) { grid.style.opacity = ''; return; }
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.getElementById('collection-product-grid');
            var curGrid = document.getElementById('collection-product-grid');
            if (newGrid && curGrid) {
              while (newGrid.firstChild) {
                curGrid.appendChild(newGrid.firstChild);
              }
            }
            var newLM = doc.getElementById('load-more-container');
            var curLM = document.getElementById('load-more-container');
            if (newLM) {
              if (curLM) { curLM.replaceWith(newLM); }
              else if (curGrid) { curGrid.insertAdjacentElement('afterend', newLM); }
            } else if (curLM) {
              curLM.remove();
            }
            page++;
            loadNext();
          })
          .catch(function() {
            grid.style.opacity = '';
          });
      }
      loadNext();
    }

    window.addEventListener('pageshow', function() {
      var raw;
      try { raw = sessionStorage.getItem(plpStateKey()); } catch (_) { return; }
      if (!raw) return;
      var state;
      try { state = JSON.parse(raw); } catch (_) { return; }
      try { sessionStorage.removeItem(plpStateKey()); } catch (_) {}

      var savedPages = parseInt(state.loadedPages, 10) || 1;
      var savedY = parseInt(state.scrollY, 10) || 0;
      if (savedPages <= 1) return;

      var currentPages = parseInt(section.dataset.loadedPages || '1', 10);
      if (currentPages >= savedPages) {
        /* bfcache: DOM already has the appended pages */
        window.scrollTo(0, savedY);
        return;
      }
      rehydrateLoadedPages(savedPages, savedY);
    });

    /* Trim the bottom row on initial server-rendered grid */
    trimPartialRow();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-recommendations"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-search-recommendations]');
    if (!root) return;

    var cfg = window.searchRecommendationsConfig || {};
    var grid = root.querySelector('[data-search-recommendations-grid]');
    var skeleton = root.querySelector('[data-search-recommendations-skeleton]');
    var headingEl = root.querySelector('[data-search-recommendations-heading]');
    if (!grid || !headingEl) return;

    var rootUrl = cfg.rootUrl || '/';
    /* Tokens are split (`'{' + '{...'`) so the theme-check JS-block scanner
       doesn't read them as embedded Liquid output tags. They are still the
       canonical Shopify money_format placeholders at runtime. */
    var TOK_AMOUNT = '{' + '{amount}}';
    var TOK_AMOUNT_NO_DEC = '{' + '{amount_no_decimals}}';
    var TOK_AMOUNT_COMMA = '{' + '{amount_with_comma_separator}}';
    var TOK_AMOUNT_NO_DEC_COMMA = '{' + '{amount_no_decimals_with_comma_separator}}';
    var moneyFormat = cfg.moneyFormat || ('$' + TOK_AMOUNT);
    var productsToShow = parseInt(cfg.productsToShow, 10) || 4;

    function hideSkeleton() {
      /* Remove the skeleton from the DOM rather than setting `.hidden = true`.
         The skeleton carries `class="grid …"` (display: grid), which overrides
         the [hidden] UA rule (display: none) on the cascade (same specificity,
         later definition wins), so the attribute flip alone leaves the element
         painted above the real tiles. Mirrors `sections/product-explore-more.liquid`
         (`assets/theme.js:945`). Removal covers all four call sites — the early-
         return when Rebuy keys aren't set, plus the three `.then` / `.catch`
         branches (Rebuy success, Rebuy empty, Rebuy fail). */
      if (skeleton) skeleton.remove();
    }

    /* ---- Heading sync — read data-has-results from search-results section ---- */
    function syncHeading() {
      var resultsSection = document.querySelector('#search-section[data-has-results]');
      var hasResults = resultsSection ? resultsSection.getAttribute('data-has-results') === 'true' : true;
      var heading = hasResults ? cfg.headingWithResults : cfg.headingNoResults;
      if (heading) headingEl.textContent = heading;
    }
    syncHeading();

    /* Re-sync when the upstream search-results section swaps its DOM
       (filter/sort/pagination via Section Rendering API). One observe() call:
       a second call on the same target REPLACES the first per spec, so we have
       to merge the options. The search-results fetchSection callback now
       re-assigns section.dataset.hasResults from the newly-fetched doc, so
       attribute mutations fire here; subtree/childList covers the inner-grid
       innerHTML swap as a belt-and-braces fallback. */
    var resultsTarget = document.getElementById('search-section');
    if (resultsTarget && 'MutationObserver' in window) {
      var obs = new MutationObserver(function () { syncHeading(); });
      obs.observe(resultsTarget, {
        attributes: true,
        attributeFilter: ['data-has-results'],
        childList: true,
        subtree: true
      });
    }

    /* With no tiles to show (no Rebuy config, empty response, or fetch
       failure, and no server-rendered fallback), hide the whole section so
       the page doesn't end on a bare heading above the footer. */
    function hideIfEmpty() {
      if (grid.children.length === 0) root.hidden = true;
    }

    /* ---- Rebuy upgrade — only if both keys are set ---- */
    if (!cfg.rebuyApiKey || !cfg.rebuyRecommendationsId) {
      /* No Rebuy → fallback grid (or empty) is the final state. Drop the
         skeleton so it doesn't sit above the fallback tiles. */
      hideSkeleton();
      hideIfEmpty();
      return;
    }

    fetchRebuyProducts(cfg)
      .then(function (products) {
        if (!products.length) {
          /* Rebuy returned nothing — keep server-rendered fallback (if any). */
          hideSkeleton();
          hideIfEmpty();
          return;
        }
        grid.innerHTML = products.map(buildTile).join('');
        hideSkeleton();
      })
      .catch(function (err) {
        console.error('[SearchRecommendations] fetch failed', err);
        /* Keep server-rendered fallback in place; drop the skeleton. */
        hideSkeleton();
        hideIfEmpty();
      });

    function fetchRebuyProducts(cfg) {
      var params = new URLSearchParams({
        key: cfg.rebuyApiKey,
        limit: String(productsToShow)
      });
      if (cfg.countryCode) params.set('country_code', cfg.countryCode);
      var url = 'https://rebuyengine.com/api/v1/custom/id/' +
        encodeURIComponent(cfg.rebuyRecommendationsId) + '?' + params.toString();

      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (json) {
          var data = json && Array.isArray(json.data) ? json.data : [];
          return data.filter(function (p) { return p && p.handle; }).slice(0, productsToShow);
        });
    }

    /* Build a product tile inline from a Rebuy product object. Mirrors
       `snippets/product-card.liquid` markup so Rebuy tiles read identically
       to server-rendered fallback tiles when they share the same grid.
       Rebuy variants[0].price / compare_at_price are strings in dollars;
       cart-drawer.js applies the same normalization. */
    function buildTile(p) {
      var handle = p.handle || '';
      var title = p.title || '';
      var vendor = p.vendor || '';
      var url = p.url || (rootUrl + 'products/' + handle);

      /* Image — Rebuy may expose .image (string or {src,alt}) or .images[] */
      var imgSrc = '';
      var imgAlt = title;
      if (typeof p.image === 'string') {
        imgSrc = p.image;
      } else if (p.image && p.image.src) {
        imgSrc = p.image.src;
        imgAlt = p.image.alt || title;
      } else if (p.images && p.images.length) {
        var first = p.images[0];
        imgSrc = typeof first === 'string' ? first : (first.src || '');
        imgAlt = (first && first.alt) || title;
      }

      /* Price — Rebuy: string dollars on variants[0]; Shopify shape: integer cents */
      var price = 0;
      var comparePrice = 0;
      if (p.variants && p.variants.length) {
        price = parseFloat(p.variants[0].price) || 0;
        comparePrice = parseFloat(p.variants[0].compare_at_price) || 0;
      } else {
        price = typeof p.price === 'number' ? p.price : parseFloat(p.price) || 0;
        comparePrice = typeof p.compare_at_price === 'number' ? p.compare_at_price : parseFloat(p.compare_at_price) || 0;
      }
      var isShopifyCents = typeof p.price === 'number' && p.price > 100;
      if (isShopifyCents) {
        price = price / 100;
        comparePrice = comparePrice / 100;
      }

      var priceHtml;
      if (comparePrice && comparePrice > price) {
        priceHtml = '<s class="text-taupe-700">' + formatMoney(comparePrice) + '</s> ' +
                    '<span class="font-semibold text-red-600">' + formatMoney(price) + '</span>';
      } else {
        priceHtml = '<span class="font-semibold">' + formatMoney(price) + '</span>';
      }

      var imgHtml = imgSrc ?
        '<img src="' + escAttr(imgSrc) + '" alt="' + escAttr(imgAlt) + '" class="absolute left-0 top-0 block size-full object-cover" loading="lazy" />' : '';

      var vendorHtml = vendor ?
        '<p class="mb-0 text-xs font-semibold tracking-wider text-taupe-700 md:text-sm">' + escHtml(vendor) + '</p>' : '';

      return '<div data-search-recommendations-tile>' +
        '<div class="h-full" data-product-card>' +
          '<div class="group relative mb-4 aspect-[9/12] overflow-hidden md:mb-5">' +
            '<a class="absolute left-0 top-0 z-[1] block size-full" href="' + escAttr(url) + '">' +
              imgHtml +
            '</a>' +
          '</div>' +
          '<div class="mb-2 flex flex-col gap-1 px-3 text-center">' +
            vendorHtml +
            '<p class="mb-0 text-base"><a href="' + escAttr(url) + '">' + escHtml(title) + '</a></p>' +
          '</div>' +
          '<div class="px-3 text-center">' +
            '<span class="mb-0 text-base">' + priceHtml + '</span>' +
          '</div>' +
        '</div>' +
      '</div>';
    }

    function formatMoney(amountInUnits) {
      var amount = parseFloat(amountInUnits);
      if (isNaN(amount)) amount = 0;
      var formatted = amount.toFixed(2);
      return moneyFormat
        .replace(TOK_AMOUNT, formatted)
        .replace(TOK_AMOUNT_NO_DEC, Math.round(amount).toString())
        .replace(TOK_AMOUNT_COMMA, formatted.replace('.', ','))
        .replace(TOK_AMOUNT_NO_DEC_COMMA, Math.round(amount).toString());
    }

    function escAttr(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
        .replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function escHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  (function() {
    var section = document.getElementById('search-section');
    if (!section) return;
    var sectionId = section.dataset.sectionId;
    var searchUrl = section.dataset.searchUrl;
    var searchTerms = section.dataset.searchTerms;

    function buildBaseUrl() {
      var u = new URL(searchUrl, window.location.origin);
      u.searchParams.set('q', searchTerms);
      u.searchParams.set('type', 'product');
      return u;
    }

    /* Trim partial bottom row, mirrors collection-template's trimPartialRow.
       The OOS skip and colour-sibling dedupe run after pagination, so a page
       of 24 can render fewer cards and leave the bottom row short while later
       pages still exist. Hide trailing cards so the visible count is a
       multiple of 4 whenever a next page exists; the final page (next arrow
       disabled) shows its partial row in full rather than hiding products
       with no later page to appear on. */
    function trimPartialRow() {
      var grid = document.getElementById('search-product-grid');
      if (!grid) return;
      var pag = document.getElementById('search-pagination');
      var links = pag ? pag.querySelectorAll('a') : [];
      var next = links.length ? links[links.length - 1] : null;
      var hasMore = next && next.getAttribute('aria-disabled') !== 'true';
      var cards = Array.prototype.slice.call(grid.children);
      var total = cards.length;
      var target = hasMore ? Math.floor(total / 4) * 4 : total;
      if (target === 0) target = total;
      for (var i = 0; i < cards.length; i++) {
        if (i < target) {
          cards[i].removeAttribute('data-row-trimmed');
          cards[i].style.removeProperty('display');
        } else {
          cards[i].setAttribute('data-row-trimmed', '');
          cards[i].style.display = 'none';
        }
      }
    }

    /* ---- Section Rendering API fetch ---- */
    function fetchSection(url) {
      var grid = document.getElementById('search-product-grid');
      if (grid) grid.style.opacity = '0.5';

      var separator = url.indexOf('?') !== -1 ? '&' : '?';
      return fetch(url + separator + 'sections=' + sectionId)
        .then(function(r) { return r.json(); })
        .then(function(json) {
          var html = json[sectionId];
          if (!html) return;

          var doc = new DOMParser().parseFromString(html, 'text/html');

          /* Mirror data-has-results from the newly-fetched outer main onto the
             live section so the search-recommendations observer can flip its
             heading. The Section Rendering API only swaps inner children
             below, so without this the attribute would stay stale and the
             "no results" heading would never appear after an AJAX filter
             narrowed the page to zero. */
          var newMain = doc.getElementById('search-section');
          if (newMain && newMain.dataset.hasResults != null) {
            section.dataset.hasResults = newMain.dataset.hasResults;
          }

          var newGrid = doc.getElementById('search-product-grid');
          var curGrid = document.getElementById('search-product-grid');
          if (newGrid && curGrid) {
            curGrid.innerHTML = newGrid.innerHTML;
            curGrid.style.opacity = '';
          }

          var newPag = doc.getElementById('search-pagination');
          var curPag = document.getElementById('search-pagination');
          if (newPag) {
            if (curPag) { curPag.replaceWith(newPag); }
            else if (curGrid) { curGrid.insertAdjacentElement('afterend', newPag); }
          } else if (curPag) {
            curPag.remove();
          }

          var newEmpty = doc.querySelector('[data-search-empty]');
          var curEmpty = document.querySelector('[data-search-empty]');
          if (newEmpty && !curEmpty && curGrid) {
            curGrid.insertAdjacentElement('afterend', newEmpty);
          } else if (!newEmpty && curEmpty) {
            curEmpty.remove();
          } else if (newEmpty && curEmpty) {
            curEmpty.replaceWith(newEmpty);
          }

          var curSidebar = document.querySelector('[data-filter-sidebar]');
          var newSidebar = doc.querySelector('[data-filter-sidebar]');
          if (curSidebar && newSidebar) {
            curSidebar.innerHTML = newSidebar.innerHTML;
          }

          var curActions = document.querySelector('[data-filter-actions]');
          var newActions = doc.querySelector('[data-filter-actions]');
          if (curActions && newActions) {
            curActions.innerHTML = newActions.innerHTML;
          }

          history.pushState(null, '', url);
          if (grid) window.scrollTo({ top: section.offsetTop, behavior: 'smooth' });

          trimPartialRow();
        })
        .catch(function() {
          if (grid) grid.style.opacity = '';
        });
    }

    /* ---- Build filter URL from form (preserves q / type / sort_by) ---- */
    function getFilterUrl() {
      var form = document.getElementById('SearchFiltersForm');
      var base = buildBaseUrl();
      if (!form) return base.toString();

      var formData = new FormData(form);
      var clean = new URLSearchParams();
      /* q and type come from hidden inputs in the form */
      formData.forEach(function(v, k) { if (v !== '') clean.append(k, v); });

      var current = new URL(window.location.href);
      var sortBy = current.searchParams.get('sort_by');
      if (sortBy) clean.set('sort_by', sortBy);

      return searchUrl + '?' + clean.toString();
    }

    /* ---- Change events ---- */
    document.addEventListener('change', function(e) {
      if (e.target.matches('[data-search-sort]')) {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        fetchSection(url.toString());
        return;
      }
      if (section.contains(e.target) || document.querySelector('[data-filter-sidebar]').contains(e.target)) {
        if (e.target.matches('[data-filter-checkbox]')) {
          fetchSection(getFilterUrl());
        }
      }
    });

    /* ---- Form submit (price range) ---- */
    document.addEventListener('submit', function(e) {
      if (e.target.matches('#SearchFiltersForm')) {
        e.preventDefault();
        fetchSection(getFilterUrl());
      }
    });

    /* ---- Click events ---- */
    document.addEventListener('click', function(e) {
      var pill = e.target.closest('[data-filter-pill]');
      if (pill && document.querySelector('[data-filter-sidebar]').contains(pill)) {
        e.preventDefault();
        fetchSection(pill.getAttribute('href'));
        return;
      }

      var clearBtn = e.target.closest('[data-filter-clear-btn]');
      if (clearBtn && !clearBtn.disabled && document.getElementById('SearchFiltersForm')) {
        var base = buildBaseUrl();
        var current = new URL(window.location.href);
        var sortBy = current.searchParams.get('sort_by');
        if (sortBy) base.searchParams.set('sort_by', sortBy);
        fetchSection(base.toString());
        return;
      }

      var pagLink = e.target.closest('#search-pagination a');
      if (pagLink && pagLink.getAttribute('href') !== '#') {
        e.preventDefault();
        fetchSection(pagLink.getAttribute('href'));
        return;
      }

      if (e.target.closest('[data-filter-open-btn]')) { openFilters(); return; }
      if (e.target.closest('[data-filter-close-btn]')) { closeFilters(); return; }
      if (e.target.closest('[data-filter-view-btn]')) { closeFilters(); return; }
      if (e.target.matches('[data-filter-backdrop]')) { closeFilters(); return; }
    });

    function openFilters() {
      var sidebar = document.querySelector('[data-filter-sidebar]');
      var backdrop = document.querySelector('[data-filter-backdrop]');
      if (sidebar) sidebar.setAttribute('data-filter-open', 'true');
      if (backdrop) backdrop.setAttribute('data-filter-open', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeFilters() {
      var sidebar = document.querySelector('[data-filter-sidebar]');
      var backdrop = document.querySelector('[data-filter-backdrop]');
      if (sidebar) sidebar.setAttribute('data-filter-open', 'false');
      if (backdrop) backdrop.setAttribute('data-filter-open', 'false');
      document.body.style.overflow = '';
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeFilters();
    });

    window.addEventListener('popstate', function() {
      fetchSection(window.location.href);
    });

    trimPartialRow();
  })();

  } catch(e) { console.error(e); }
})();
})();
